// extracted by mini-css-extract-plugin
module.exports = {"border":"AssetFormItem_border__1YPti","header":"AssetFormItem_header__8j_Hu","error":"AssetFormItem_error__rIVES","input":"AssetFormItem_input__3kjZh"};